<template>
    <div  :style="{'height':clientHeight-90+'px'}">
        <vue-scroll :ops="$ops">
            <div >
                <div class="m-portlet m-b-10">
                    <div class="m-portlet__body">
                        <el-form>
                            <el-row :gutter="20">
                                <el-col :span="6">
                                    <el-form-item label="选择学期">
                                        <el-select v-model="semesterType_ids"  placeholder="请选择学期"
                                                   multiple
                                                   clearable
                                                   @change="handleChangeSemester()">
                                            <el-option
                                                    v-for="item in semesterTypes"
                                                    :key="item.id"
                                                    :label="item.name"
                                                    :value="item.id">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="6">
                                    <el-form-item label="选择折扣">
                                        <el-select v-model="discountTypeDetail_id"
                                                   placeholder="请选择折扣"
                                                   filterable
                                                   remote
                                                   clearable
                                                   @change="handleIndex()"
                                                   :remote-method="handleSearchDiscountType">
                                            <el-option
                                                    v-for="item in discountTypeDetails"
                                                    :key="item.id"
                                                    :label="item.discountType_name"
                                                    :value="item.id">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-form>
                    </div>
                </div>
                <div class="m-portlet m-b-0">
                    <div class="m-portlet__body" v-loading="loading">
                        <el-table
                                :data="data"
                                size="middle"
                                style="width: 100%"
                        >
                            <el-table-column type="expand">
                                <template slot-scope="props">
                                    <el-table
                                            :data="props.row.students"
                                            size="middle"
                                            height="400"
                                            style="width: 100%;margin-bottom: 20px;"
                                    >
                                        <el-table-column prop="student_name" label="学生" ></el-table-column>
                                        <el-table-column prop="invoice_id" label="合同编号"></el-table-column>
                                        <el-table-column prop="balance" label="折扣"  ></el-table-column>
                                    </el-table>
                                </template>
                            </el-table-column>
                            <el-table-column prop="id" label="编号" ></el-table-column>
                            <el-table-column prop="discountType_name" label="折扣名"></el-table-column>
                            <el-table-column prop="type" label="折扣类型">
                                <template slot-scope="scope">
                                    <div v-if="scope.row.type=='balance'">
                                        现金优惠
                                    </div>
                                    <div v-if="scope.row.type=='discount'">
                                        折扣优惠
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="balance" label="折扣"></el-table-column>
                            <el-table-column prop="number" label="使用次数"></el-table-column>
                        </el-table>
                        <!--分页-->
                        <div class="text-center m-t-10">
                            <el-pagination
                                    @size-change="handleSizeChange"
                                    @current-change="handleCurrentChange"
                                    :current-page="currentPage"
                                    :page-sizes="[10, 20, 50, 100]"
                                    :page-size="10"
                                    layout="total, sizes, prev, pager, next, jumper"
                                    :total="total">
                            </el-pagination>
                        </div>
                    </div>
                </div>
            </div>
        </vue-scroll>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                path:"/renewalDiscountType/list",
                semesterTypes:[],
                semesterType_ids:[],
                discountTypeDetails:[],
                discountTypeDetail_id:'',
                data:[],
                loading: true,
                total: 0,
                currentPage: 1,
                currentPageSize: 10,
            };
        },
        mounted() {
            this.$nextTick(() => {
            })
        },
        created() {
            this.handleCreate();
            this.handleShow();
            this.handleIndex();
        },
        computed: {
            right_level() {
                return this.$store.state.user.employee.right_level;
            },
            clientHeight() {
                return this.$store.state.config.clientHeight
            },
        },
        methods: {
            handleCreate(){
                //建立webSocket链接
                this.$wApi.addListen(this.path,this.handleData);
            },
            handleShow() {
                this.$wApi.send(this.path,'init',{});
            },
            handleData(event,data){
                switch (event) {
                    case 'init':
                        this.semesterTypes =data.semesterTypes;
                        this.discountTypeDetails=data.discountTypeDetails;
                        break;
                    case 'search_discountType':
                        this.discountTypeDetails = data.discountTypeDetails;
                        break;
                    case 'list':
                        this.total = data.total;
                        this.data = data.list;
                        this.loading = false;
                        break;
                }
            },
            handleIndex(currentPage = 1) {
                if (currentPage === 1) {
                    this.currentPage = 1
                }
                this.$wApi.send(this.path, 'list', {
                    'currentPage': this.currentPage,
                    'currentPageSize': this.currentPageSize,
                    'semesterType_ids': this.semesterType_ids,
                    'discountType_detail_ids': this.discountTypeDetail_id,
                });
            },
            handleChangeSemester(){
                this.handleSearchDiscountType('')
                this.handleIndex();
            },
            handleSizeChange(val) {
                this.currentPageSize = val;
                this.loading = true;
                this.handleIndex(this.currentPage, this.currentPageSize)
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.loading = true;
                this.handleIndex(this.currentPage, this.currentPageSize)
            },
            handleSearchDiscountType(query){
                this.$wApi.send(this.path, 'search_discountType', {
                    'semesterType_ids':this.semesterType_ids,
                    'name': query,
                })
            }
        }
    }
</script>

<style scoped>

</style>